export default __webpack_public_path__ + "static/media/sd-donations-banner-img.afe30e0f.png";